import React from "react";

const VARIANT_CLASSES = {
  discard: {
    cancel: "tw-bg-[#FF43A7] hover:tw-bg-[#FF00A0] tw-text-[#570033] tw-border-none tw-shadow-[0_0_15px_rgba(255,67,167,0.4)]",
    confirm: "tw-bg-transparent tw-border tw-border-red-500 tw-text-red-500 hover:tw-bg-red-500 hover:tw-text-white",
  },
  delete: {
    cancel: "tw-bg-transparent tw-border tw-border-[#5A3F49] tw-text-[#E2BDC9] hover:tw-bg-white/5",
    confirm: "tw-bg-red-500 hover:tw-bg-red-600 tw-text-white tw-border-none tw-shadow-[0_0_15px_rgba(239,68,68,0.4)]",
  },
};

export default function ConfirmDialog({
  isOpen,
  title,
  children,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  variant = "discard",
}) {
  if (!isOpen) return null;

  const classes = VARIANT_CLASSES[variant];

  return (
    <div className="tw-fixed tw-inset-0 tw-z-[1060] tw-flex tw-items-center tw-justify-center tw-bg-[#0a0014]/90 tw-backdrop-blur-sm tw-p-4">
      <div className="tw-bg-[#280D41] tw-border tw-border-[#5A3F49]/40 tw-rounded-2xl tw-p-6 md:tw-p-8 tw-max-w-md tw-w-full tw-shadow-[0_20px_50px_rgba(0,0,0,0.5)]">
        <h3 className="tw-text-white tw-text-xl md:tw-text-2xl tw-font-bold tw-mb-4 tw-font-['Plus_Jakarta_Sans']">
          {title}
        </h3>
        <p className="tw-text-[#E2BDC9] tw-text-sm tw-mb-8 tw-leading-relaxed">
          {children}
        </p>
        <div className="tw-flex tw-justify-end tw-gap-4">
          <button
            onClick={onCancel}
            className={`tw-px-6 tw-py-2.5 tw-rounded-lg tw-font-bold tw-text-sm tw-uppercase tw-tracking-widest tw-transition-colors tw-cursor-pointer ${classes.cancel}`}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`tw-px-6 tw-py-2.5 tw-rounded-lg tw-font-bold tw-text-sm tw-uppercase tw-tracking-widest tw-transition-colors tw-cursor-pointer ${classes.confirm}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
